export const ADD_FIELD = "ADD_FIELD";
export const REQUEST_FIELD_TYPES = "REQUEST_FIELD_TYPES";
export const SET_FIELD_TYPES = "SET_FIELD_TYPES";